import * as React from "react";

import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper,
  fontWeightHelper
} from "../../theme/theme-helper";
import { HalfColumnWidthWrapper } from "../confines-wrappers";
import { IFieldTechnicalArticleColumnType } from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  readTime?: string;
}

interface IReadTimeWrapper {
  type: IFieldTechnicalArticleColumnType;
}

const ReadTimeWrapper = styled<IReadTimeWrapper>(HalfColumnWidthWrapper)`
  padding-top: 2.6rem;
  color: ${({ theme }) => colourHelper({
    theme,
    variant: "lightGrey"
  })};
  font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "small_3"
  })};
  font-weight: ${({ theme }) => fontWeightHelper({
    theme,
    variant: "light"
  })};
  line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "default"
    })};
`;

const ReadTime = ({ type, readTime }: IProps) => {
  if (!readTime) {
    return null;
  }

  return (
    <ReadTimeWrapper type={type}>
      <span className="read-time">
        {readTime}
      </span>
    </ReadTimeWrapper>
  );
};

export default ReadTime;
